import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
// @mui
import {
  Card,
  Grid,
  Paper, Box,
  Typography,
  Backdrop,
  CircularProgress,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { format } from 'date-fns';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import 'react-tabs/style/react-tabs.css';
import ReactApexChart from 'react-apexcharts';
import { makeStyles } from '@mui/styles';
import merge from 'lodash/merge';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { BaseOptionChart } from '../../../chart';
// components

import { EdCard1RestCallForCard, EdCard1RestCallForGraphCard, EdCard1RestCallForGraphCardByDate } from "../EdCard1RestCall"
import EdgeDeviceInfo from '../../../EdgeDeviceInfoComponents/EdgeDeviceInfoDashboard/EdgeDeviceInfo';
// import InternalRechablityApiCall from '../InternalRechablityApiCall';
import TroubleshootComponent from '../TroubleshootComponents/TroubleshootComponent';
import timeArray from '../TimeData';
import ISPPaused1SubCards from './EdPaused1SubCards';


// sections

// ----------------------------------------------------------------------
const useStyles = makeStyles({
  boxPadding: {
    padding: '25px',
  },
  boxItems: {
    display: 'flex',
    alignItems: 'center',
  },
  titleStyle: {
    padding: 24,
  },
});

export default function EdPaused1Card1(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [ispParams, setIspParams] = useState({});
  const [jitterData, setJitterData] = useState([]);
  const [latencyData, setLatencyData] = useState([]);
  const [packetLossData, setPacketLossData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [upDownSeriesData, setUpDownSeriesData] = useState([]);

  const [timeData, setTimeData] = useState([]);
  const [statusTimeData, setStatusTimeData] = useState([]);

  const [inBandWidthData, setInBandWidthData] = useState([]);
  const [outBandWidthData, setOutBandWidthData] = useState([]);
  const [bandWidthTimeData, setBandWidthTimeData] = useState([]);

  const [openBackdrop, setOpenBackdrop] = useState(true);

  const [openTroubleshoot, setOpenTroubleshoot] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const [formattedDate, setFormattedDate] = useState("");

  const custId = localStorage.getItem("cust_id");



  // Code to Written TO fetch single isp info and display
  const params = useParams();

  const intervalRef = useRef();

  const handleTimeChange = (event, newTimeValue) => {
    setOpenBackdrop(true);
    setSelectedDate(null);
    intervalRef.time = newTimeValue;
    // EdCard1RestCallForGraphCard(params.id, intervalRef.time, setJitterData, setLatencyData, setPacketLossData, setStatusData, setTimeData, setStatusTimeData, setOpenBackdrop);
    _EdCard1RestCallForGraphCard();
    // _EdCard1BandWidthData();
  };

  const handleDateChange = (date) => {
    intervalRef.time = -1;
    setSelectedDate(date);
    if (date) {
      const formattedDate = format(date, 'yyyy-MM-dd');
      setFormattedDate(formattedDate);
    }
  };

  const _EdCard1RestCallForCard = async () => {
    EdCard1RestCallForCard(params.id, setIspParams);
  }

  useEffect(() => {
    _EdCard1RestCallForCard();
  }, []);


  const _EdCard1RestCallForGraphCardByDate = async () => {
    await EdCard1RestCallForGraphCardByDate(params.id, formattedDate, setJitterData, setLatencyData, setPacketLossData, setStatusData, setTimeData, setStatusTimeData, setUpDownSeriesData, setOpenBackdrop);
  }

  // const _EdCard1BandWidthDataByDate = async () => {
  //   await EdCard1BandWidthDataByDate(params.id, formattedDate, setInBandWidthData, setOutBandWidthData, setBandWidthTimeData);
  // }

  useEffect(() => {
    setOpenBackdrop(true);
    if (formattedDate !== "") {
      _EdCard1RestCallForGraphCardByDate();
      // _EdCard1BandWidthDataByDate();
    }
    // _EdCard1BandWidthDataByDate();
  }, [formattedDate])

  const _EdCard1RestCallForGraphCard = async () => {
    await EdCard1RestCallForGraphCard(params.id, intervalRef.time, setJitterData, setLatencyData, setPacketLossData, setStatusData, setTimeData, setStatusTimeData, setUpDownSeriesData, setOpenBackdrop);
  }

  // const _EdCard1BandWidthData = async () => {
  //   await EdCard1BandWidthData(params.id, intervalRef.time, setInBandWidthData, setOutBandWidthData, setBandWidthTimeData);
  // }

  useEffect(() => {
    intervalRef.time = timeArray[0].value;
    _EdCard1RestCallForGraphCard();
    // _EdCard1BandWidthData();
    _EdCard1RestCallForCard();
    // setInterval(() => {
    //   _EdCard1RestCallForGraphCard();
    //   _EdCard1RestCallForCard();
    //   _EdCard1BandWidthData();
    // }, 60 * 1000);
  }, []);

  const appTimeData = timeData; 
  const unit = 'ms'; 
  const plUnit = "%";
  const utilizationUnit = 'mbps';
  const categories = [''];
    const upTimeUnit = 'minutes';

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const state0 = [
    {
      name: 'Latency',
      type: 'area',
      fill: 'gradient',
      data: latencyData,
    },
    {
      name: 'Jitter',
      type: 'line',
      fill: 'solid',
      data: jitterData,
    },
  ];

  const chartLabels = timeData;

  const chartOptions = merge(BaseOptionChart(), {
    plotOptions: { bar: { columnWidth: '16%' } },
    fill: { type: state0.map((i) => i.fill) },
    labels: chartLabels,
    xaxis: {
      type: "time",
      tickAmount: 12
    },
    yaxis: {
      title: {
        text: 'Mili Seconds'
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} ms`;
          }
          return y;
        },
      },
    },
  });

  const state1 = {
    series: [
      {
        name: 'PL Percent',
        data: packetLossData,
      },
    ],
    options:
    {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'time',
        tickAmount: 12,
        categories: timeData,
      },
      yaxis: {
        title: {
          text: 'Packet Loss(%)'
        },
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm',
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: "100%",
              height: "100%"
            },
            legend: {
              show: false
            }
          }
        }
      ]
    },
  };

  const state2 = {
    series: [{
      name: "Status",
      data: statusData
    }],
    options: {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'stepline',
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0
        },
      },
      xaxis: {
        type: 'time',
        tickAmount: 12,
        categories: statusTimeData,
      },
      yaxis: {
        tickAmount: 1,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: "100%",
              height: "100%"
            },
            legend: {
              show: false
            }
          }
        }
      ]
    },
  };

  const barState = {
    series: upDownSeriesData,
    options: {
      chart: {
        type: 'bar',
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {}
        },
      },
      title: {
        text: '',
      },
      xaxis: {
        categories: [''],
        labels: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
        labels: {},
      },
      tooltip: {
        y: {
          formatter: (val) => `${val} minutes`,
        },
        labels: {
          show: false,
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40,
        show: false,
      },
    },
  };

  // const state3 = [

  //   {
  //     name: 'Download',
  //     type: 'line',
  //     fill: 'solid',
  //     data: inBandWidthData, 
  //   },
  //   {
  //     name: 'Upload',
  //     type: 'area',
  //     fill: 'gradient',
  //     data: outBandWidthData,
  //   }

  // ];

  // const chartLabels3 = bandWidthTimeData;
  // const chartOptions3 = merge(BaseOptionChart(), {
  //   fill: { type: state3.map((i) => i.fill) },
  //   labels: chartLabels3,
  //   xaxis: {
  //     type: 'time',
  //     tickAmount: 12
  //   },
  //   tooltip: {
  //     shared: true,
  //     intersect: false,
  //     y: {
  //       formatter: (y) => {
  //         if (typeof y !== 'undefined') {
  //           return `${y.toFixed(4)} MB/s`;
  //         }
  //         return y;
  //       },
  //     },
  //   },
  // });

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
        <Typography position='absolute'><strong>Loading.....</strong></Typography>
      </Backdrop>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Paper elevation={15}>
          <div className={classes.titleStyle}>
            <Typography>
              {/* {ispParams.location_name} - {ispParams.vendor_name} - {ispParams.device_ip} */}
              {ispParams.vendor_name} - {ispParams.device_ip}
            </Typography>
          </div>

          <ISPPaused1SubCards ispParams={ispParams} />

          <div className={classes.titleStyle}>
            <FormLabel id="demo-row-radio-buttons-group-label">Select Time</FormLabel>
            <Grid container>
              <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={intervalRef.time ? intervalRef.time : timeArray[0].value}
                  onChange={handleTimeChange}
                >

                  {timeArray.map((data, index) => (
                    <FormControlLabel
                      key={index}
                      value={data.value}
                      control={<Radio />}
                      label={data.label}
                      // Disable "Last 2 Week" option unless "Last 1 Week" is selected
                      disabled={data.value === "336 HOUR" && (intervalRef.time !== "168 HOUR" && intervalRef.time !== "336 HOUR")}
                    />
                  ))}
                  {/* <FormControlLabel value={"-1"} control={<Radio />} label={"Custom Date"} disabled/> */}
                </RadioGroup>
              </Grid>
              {/* <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Select Date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid> */}
            </Grid>
          </div>

          <Grid container spacing={3} sx={{ px: 2, py: 2 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card variant="outlined" elevation={15}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Latency/jitter" />
                  <Tab label="Packet loss" />
                  <Tab label="Up Time" />
                  {/* <Tab label="Utilization" /> */}
                </Tabs>
                <TabPanel value={value} index={0}>
                  <Box paddingX={2}>
                    {/* <ReactApexChart type="line" series={state0} options={chartOptions} height={350} /> */}
                    {(latencyData?.length > 0 || jitterData?.length > 0) ? (
                  <ReactEcharts
                                        option={{
                                          color: ['blue', '#FFEA00'],
                                          grid: {
                                            left: "3%",
                                            right: "3%",
                                           bottom : 90,
                                          },
                                          tooltip: {
                                            trigger: 'axis',
                                            backgroundColor: '#ffffff',
                                            borderWidth: 1,
                                            borderColor: '#ddd',
                                            padding: 12,
                                            textStyle: {
                                              color: '#333',
                                              fontFamily: 'Arial, sans-serif',
                                              fontSize: 13
                                            },
                                            extraCssText: 'box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2); border-radius: 8px;',
                                            formatter (params) {
                                              const time = appTimeData[params[0]?.dataIndex] || 'N/A';
                                      
                                              return `
                                                <div style="width: 275px; padding: 4px; font-family: Arial, sans-serif;">
                                                  <div style="background: #f5f5f5; padding: 2px; border-radius: 6px 6px 0 0; text-align: center;">
                                                    <span style="font-size: 14px; font-weight: bold; color: #444;">
                                                      🕒 <span style="color: #007bff;">${time}</span>
                                                    </span>
                                                  </div>
                                                  <hr style="border: 0; height: 1px; background: #ddd; margin: 3px 0;">
                                                  ${params
                                                    .map(
                                                      (param) => `
                                                      <div style="display: flex; justify-content: space-between; align-items: center; margin: 3px 0; gap: 8px;">
                                                        <span style="color: ${param.color}; font-weight: 600; flex: 1; white-space: nowrap;">
                                                          ● ${param.seriesName}:
                                                        </span>
                                                        <span style="font-weight: bold; color: #222; text-align: right; flex: 1; font-family: monospace; white-space: nowrap;">
                                                          ${param.value.toFixed(2)} ${unit}
                                                        </span>
                                                      </div>
                                                    `
                                                    )
                                                    .join('')}
                                                </div>
                                              `;
                                            }
                                          },
                                          
                                          legend: {
                                            data: ['Latency', 'Jitter'],
                                            bottom : 0,
                                          },
                                           xAxis: {
                            type: 'category',
                            data: timeData,
                            boundaryGap: false,
                            axisLabel: {
                              formatter(value) {
                                const [time, date] = value.split('\n').map((s) => s.trim());
                                const [hour, minute, , period] = time.split(/[: ]/);
                                return `${hour}:${minute} ${period} \n ${date}`;
                              },
                            },
                          },
                                          yAxis: {
                                            type: 'value',
                                            name: 'ms'
                                          },
                                          series: [
                                            {
                                              name: 'Latency',
                                              type: 'line',
                                              data: latencyData,
                                              smooth: true,
                                              symbol: 'circle', 
                                              showSymbol: true, 
                                              lineStyle: { color: 'blue' },
                                              areaStyle: {
                                                color: 'rgba(0, 0, 255, 0.1)' // Light blue fill under the line
                                              }
                                            },
                                            {
                                              name: 'Jitter',
                                              type: 'line',
                                              data: jitterData,
                                              smooth: true,
                                              symbol: 'circle', 
                                              showSymbol: true, 
                                              lineStyle: { color: '#FFEA00' },
                                              areaStyle: {
                                                color: 'rgba(255, 234, 0, 0.2)' // Light yellow fill under the line
                                              }
                                            }
                                          ],
                                          toolbox: {
                                            feature: {
                                              saveAsImage: {
                                                title: 'Save Image',
                                                name: 'chart',
                                                type: 'png',
                                                pixelRatio: 2,
                                                backgroundColor: '#fff'
                                              },
                                              dataZoom: {
                                                yAxisIndex: 'none',
                                                title: {
                                                  zoom: 'Zoom by dragging',
                                                  back: 'Restore original view'
                                                }
                                              },
                                            
                                            },
                                            right: 20
                                          },
                                        }}
                                        style={{ height: 350 }}
                                      />):(
                                        <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', padding: '11rem' }}>
                                        No data at the moment
                                      </div>
                                     )}
                  </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Box paddingX={2}>
                    {/* <ReactApexChart options={state1.options} series={state1.series} type="area" height={350} /> */}
                    {(packetLossData?.length > 0 ) ? (
                   <ReactEcharts
                                      option={{
                                        color: ['blue', '#FFEA00'],
                                        grid: {
                                          left: "3%",
                                          right: "3%",
                                          bottom : 90,
                                        },
                                        tooltip: {
                                          trigger: 'axis',
                                          backgroundColor: '#ffffff',
                                          borderWidth: 1,
                                          borderColor: '#ddd',
                                          padding: 12,
                                          textStyle: {
                                            color: '#333',
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: 13
                                          },
                                          extraCssText: 'box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2); border-radius: 8px;',
                                        formatter (params) {
                                            const time = appTimeData[params[0]?.dataIndex] || 'N/A';
                                    
                                            return `
                                              <div style="width: 275px; padding: 4px; font-family: Arial, sans-serif;">
                                                <div style="background: #f5f5f5; padding: 2px; border-radius: 6px 6px 0 0; text-align: center;">
                                                  <span style="font-size: 14px; font-weight: bold; color: #444;">
                                                    🕒 <span style="color: #007bff;">${time}</span>
                                                  </span>
                                                </div>
                                                <hr style="border: 0; height: 1px; background: #ddd; margin: 3px 0;">
                                                ${params
                                                  .map(
                                                    (param) => `
                                                    <div style="display: flex; justify-content: space-between; align-items: center; margin: 3px 0; gap: 8px;">
                                                      <span style="color: ${param.color}; font-weight: 600; flex: 1; white-space: nowrap;">
                                                        ● ${param.seriesName}:
                                                      </span>
                                                      <span style="font-weight: bold; color: #222; text-align: right; flex: 1; font-family: monospace; white-space: nowrap;">
                                                        ${param.value.toFixed(2)} ${plUnit}
                                                      </span>
                                                    </div>
                                                  `
                                                  )
                                                  .join('')}
                                              </div>
                                            `;
                                          }
                                        },
                                         xAxis: {
                            type: 'category',
                            data: timeData,
                            boundaryGap: false,
                            axisLabel: {
                              formatter(value) {
                                const [time, date] = value.split('\n').map((s) => s.trim());
                                const [hour, minute, , period] = time.split(/[: ]/);
                                return `${hour}:${minute} ${period} \n ${date}`;
                              },
                            },
                          },
                                        yAxis: {
                                          type: 'value',
                                          name: '%'
                                        },
                                        legend: {
                                          data: ['Packet Loss'],
                                          bottom : 0,
                                        },
                                        series: [
                                          {
                                            name: 'Packet Loss',
                                            type: 'line',
                                            data: packetLossData,
                                            smooth: true,
                                            areaStyle: {
                                              opacity: 0.2,
                                              color: 'blue'
                                            },
                                            lineStyle: {
                                              color: 'blue',
                                              width: 2
                                            },
                                            symbol: 'circle', 
                                            showSymbol: true, 
                                          }
                                        ],
                                        toolbox: {
                                          feature: {
                                            saveAsImage: {
                                              title: 'Save Image',
                                              name: 'chart',
                                              type: 'png',
                                              pixelRatio: 2,
                                              backgroundColor: '#fff'
                                            },
                                            dataZoom: {
                                              yAxisIndex: 'none',
                                              title: {
                                                zoom: 'Zoom by dragging',
                                                back: 'Restore original view'
                                              }
                                            },
                                          
                                          },
                                          right: 20
                                        },
                                      }}
                                      style={{ height: 350 }}
                                    /> ):(
                                      <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', padding: '11rem' }}>
                                      No data at the moment
                                    </div>
                                   )}
                  </Box>
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Box paddingX={2}>
                    {/* <ReactApexChart options={barState.options} series={barState.series} type="bar" height={350} /> */}
                    {(upDownSeriesData?.length > 0 ) ? (
                    <ReactEcharts
                    option={{
                      tooltip: {
                        trigger: 'item', // 👈 changed from 'axis' to 'item'
                        backgroundColor: '#ffffff',
                        borderWidth: 1,
                        borderColor: '#ddd',
                        padding: 12,
                        textStyle: {
                          color: '#333',
                          fontFamily: 'Arial, sans-serif',
                          fontSize: 13,
                        },
                        extraCssText:
                          'box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2); border-radius: 8px;',
                        formatter (param) {
                          const index = param?.dataIndex;
                          const time = appTimeData[index] || 'N/A';
                      
                          return `
                            <div style="width: 260px; padding: 4px; font-family: Arial, sans-serif;">
                              <div style="background: #f5f5f5; padding: 2px; border-radius: 6px 6px 0 0; text-align: center;">
                                <span style="font-size: 14px; font-weight: bold; color: #444;">
                                  🕒 <span style="color: #007bff;">${time}</span>
                                </span>
                              </div>
                              <hr style="border: 0; height: 1px; background: #ddd; margin: 3px 0;">
                              <div style="display: flex; justify-content: space-between; align-items: center; margin: 3px 0;">
                                <span style="color: ${param.color}; font-weight: 600; flex: 1;">
                                  ● ${param.seriesName}:
                                </span>
                                <span style="font-weight: bold; color: #222; font-family: monospace;">
                                  ${param.value.toFixed(2)} ${upTimeUnit}
                                </span>
                              </div>
                            </div>
                          `;
                        },
                      },
                      toolbox: {
                        show: true,
                        orient: 'horizontal',
                        left: 'right',
                        top: 7,
                        feature: {
                          saveAsImage: {
                            show: true,
                            title: 'Save as Image',
                            name: 'chart',
                            backgroundColor: 'white',
                            pixelRatio: 2,
                          },
                        },
                      },
                      
                      grid: {
                        left: '3%',
                        right: '3%',
                        bottom: '10%',
                        containLabel: true,
                      },
                      xAxis: {
                        type: 'value',
                        show: true,
                      },
                      yAxis: {
                        type: 'category',
                        data: categories,
                        show: false,
                      },
                      // series: upDownSeriesData.map((item) => {
                      //   const lowerName = item.name.toLowerCase();
                      //   const color = lowerName.includes('down') ? '#F07470' : '#A7F1A8';
                      
                      //   return {
                      //     name: item.name,
                      //     type: 'bar',
                      //     stack: 'total',
                      //     data: item.data,
                      //     barWidth: 230,
                      //     itemStyle: {
                      //       color
                      //     },
                      //     label: {
                      //       show: true,
                      //       position: 'inside',
                      //       formatter (params) {
                      //         const value = params.value || 0;
                      //         return `${value} `;
                      //       },
                      //       color: 'white',
                      //       fontWeight: 'bold',
                      //       fontSize: 12,
                      //     }
                      //   };
                      // }),
                        series: upDownSeriesData.map((item) => {
                            const lowerName = item.name.toLowerCase();
                            let color = '#A7F1A8'; // default: up = green

                            if (lowerName.includes('down')) {
                              color = '#F07470'; // red for down
                            } else if (lowerName.includes('not')) {
                              color = '#CFCFC4'; // grey for not-monitored
                            }

                            return {
                              name: item.name,
                              type: 'bar',
                              stack: 'total',
                              data: item.data,
                              barWidth: 230,
                              itemStyle: {
                                color,
                              },
                              label: {
                                show: false,
                                position: 'inside',
                                formatter(params) {
                                  const value = params.value || 0;
                                  return `${value} `;
                                },
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: 12,
                              }
                            };
                          }),
                    }}
                    style={{ height: 350 }}
                  /> ):(
                    <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center', padding: '11rem' }}>
                    No data at the moment
                  </div>
                 )}
                  </Box>
                </TabPanel>
                {/* <TabPanel value={value} index={3}>
                  <Box paddingX={2}>
                    <ReactApexChart type="line" series={state3} options={chartOptions3} height={350} />
                  </Box>
                </TabPanel> */}
              </Card>
            </Grid>
            {openTroubleshoot && <TroubleshootComponent openTroubleshoot={openTroubleshoot} setOpenTroubleshoot={setOpenTroubleshoot} ispParams={ispParams} />}
          </Grid>
          {custId === "81" && <Grid container spacing={3} sx={{ px: 2, py: 2 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card variant="outlined" elevation={15}>
                <EdgeDeviceInfo deviceIps={ispParams.device_ip} />
              </Card>
            </Grid>
          </Grid>}
        </Paper>
      </Grid>
    </>
  );
}
